(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uv-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uv-bundle')) {
    customElements.define(
      'uv-bundle',
      class UvBundle extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-bundle-add]');
          this.items = Array.from(this.querySelectorAll('[data-bundle-item]')).map((element) => {
            const data = JSON.parse(element.querySelector('[data-bundle-item-json]').textContent);
            const tierTable =
              data.tierTable && typeof data.tierTable === 'object' && !Array.isArray(data.tierTable)
                ? Object.fromEntries(Object.entries(data.tierTable).map(([key, value]) => [key.toLowerCase(), value]))
                : null;
            return {
              ...data,
              tierTable,
              element,
              input: element.querySelector('[data-bundle-check]'),
              variant: data.variants.find((variant) => variant.id === data.variantId) || data.variants[0],
            };
          });

          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-bundle-check]')) this.update();
          });
          this.button.addEventListener('click', () => this.addToCart());

          this.onVariantChange = (event) => this.matchVariant(event.detail);
          document.addEventListener('harmony:variant-change', this.onVariantChange);

          this.update();
        }

        disconnectedCallback() {
          document.removeEventListener('harmony:variant-change', this.onVariantChange);
        }

        matchVariant({ productId, variantId, options }) {
          const [current, ...added] = this.items;
          if (!current || current.productId !== productId) return;

          current.variant = current.variants.find((variant) => variant.id === variantId) || current.variant;
          added.forEach((item) => {
            item.variant =
              item.variants.find((v) => v.available && v.options.join('||') === options.join('||')) ||
              item.variants.find((v) => v.available && v.options[0] === options[0]) ||
              item.variants.find((v) => v.available) ||
              item.variant;
          });
          this.update();
        }

        // Matches the Harmony Discounts checkout rules. The tier item is discounted by
        // the number of icons; the full set gives every icon its own discount; any other
        // bundle with 2+ icons gives the 2-icon discount to the first icon only.
        bundlePrices(selection) {
          const prices = new Map(selection.map((item) => [item, item.variant.price]));
          if (selection.length < 2) return prices;

          const rate = Number(window.Shopify?.currency?.rate) || 1;
          const icons = selection.filter((item) => !item.tierTable);
          const tierItems = selection.filter((item) => item.tierTable);
          const goldLeafs = this.goldLeafs(icons);
          const takeOff = (item, cents) =>
            prices.set(item, Math.max(item.variant.price - Math.round(cents), 0));

          if (this.isFullSet(icons.length, tierItems, goldLeafs)) {
            icons.forEach((item) => {
              const { price, percentOff, amountOff } = item.variant;
              if (percentOff > 0) takeOff(item, (price * Math.min(percentOff, 100)) / 100);
              else if (amountOff > 0) takeOff(item, amountOff * rate * 100);
            });
          } else if (icons.length >= 2 && icons[0].variant.pairOff > 0) {
            takeOff(icons[0], icons[0].variant.pairOff * rate * 100);
          }
          tierItems.forEach((item) =>
            takeOff(item, this.tierAmount(item.tierTable, icons.length, goldLeafs) * rate * 100)
          );
          return prices;
        }

        goldLeafs(icons) {
          return [...new Set(icons.map((item) => item.variant.title.toLowerCase()))];
        }

        tierLists(table, goldLeafs) {
          return (goldLeafs.length ? goldLeafs : ['default']).map((goldLeaf) => {
            const tiers = Array.isArray(table[goldLeaf]) ? table[goldLeaf] : table.default;
            return Array.isArray(tiers) ? tiers : [];
          });
        }

        // Entry N-1 applies when N icons are in the bundle; mixed gold leafs use the smallest.
        tierAmount(table, count, goldLeafs) {
          if (count < 1) return 0;
          const amounts = this.tierLists(table, goldLeafs).map((tiers) =>
            tiers.length ? Number(tiers[Math.min(count, tiers.length) - 1]) || 0 : 0
          );
          return Math.min(...amounts);
        }

        // A tier table's length is the number of icons in the full set.
        isFullSet(iconCount, tierItems, goldLeafs) {
          return tierItems.some((item) => {
            const size = Math.max(...this.tierLists(item.tierTable, goldLeafs).map((tiers) => tiers.length));
            return size > 0 && iconCount >= size;
          });
        }

        // The selection after checking `added`, including a tier item it would lock on.
        withForcedItems(added) {
          const icons = this.items.filter((item) => !item.tierTable && (item === added || item.input.checked));
          const goldLeafs = this.goldLeafs(icons);
          return this.items.filter(
            (item) =>
              item === added ||
              item.input.checked ||
              (item.tierTable && item.variant.available && this.isFullSet(icons.length, [item], goldLeafs))
          );
        }

        update() {
          this.items.forEach((item) => {
            const available = item.variant.available;
            item.element.classList.toggle('uv-bundle__item--unavailable', !available);
            if (!available) item.input.checked = false;
            if (item.locked && available) item.input.checked = true;
          });

          // Every icon checked keeps the tier item (Lampada Kit) checked and locked.
          const checkedIcons = this.items.filter((item) => !item.tierTable && item.input.checked);
          const checkedGoldLeafs = this.goldLeafs(checkedIcons);
          this.items.forEach((item) => {
            const available = item.variant.available;
            const forced =
              Boolean(item.tierTable) && available && this.isFullSet(checkedIcons.length, [item], checkedGoldLeafs);
            if (forced) item.input.checked = true;
            item.input.disabled = item.locked || !available || forced;
          });

          const selected = this.items.filter((item) => item.input.checked);
          const prices = this.bundlePrices(selected);
          let total = 0;
          let compareTotal = 0;
          let tierSavings = 0;
          let tierItem = null;

          this.items.forEach((item) => {
            const price = item.variant.price;
            // Unchecked items show what they would cost once checked.
            const bundlePrice = item.input.checked
              ? prices.get(item)
              : this.bundlePrices(this.withForcedItems(item)).get(item);
            const discounted = bundlePrice < price;
            const shownPrice = item.tierTable ? bundlePrice : price;

            item.element.querySelector('[data-bundle-price]').textContent =
              shownPrice === 0 && this.dataset.freeLabel ? this.dataset.freeLabel : this.formatMoney(shownPrice);
            const compare = item.element.querySelector('[data-bundle-compare]');
            compare.textContent = this.formatMoney(price);
            compare.hidden = shownPrice >= price;

            const subtitle = item.element.querySelector('[data-bundle-subtitle]');
            const variantLabel = item.showVariant && item.variants.length > 1 ? item.variant.title : '';
            subtitle.textContent = [subtitle.dataset.base, variantLabel].filter(Boolean).join(' | ');

            const image = item.element.querySelector('[data-bundle-image]');
            if (image && item.variant.image && !image.src.startsWith(item.variant.image.split('?')[0])) {
              image.removeAttribute('srcset');
              image.src = item.variant.image;
            }

            if (item.input.checked) {
              total += bundlePrice;
              compareTotal += price;
              if (item.tierTable && discounted) {
                tierSavings += price - bundlePrice;
                tierItem = tierItem || { name: item.name, free: bundlePrice === 0 };
              }
            }
          });

          const savings = compareTotal - total;
          const savingsElement = this.querySelector('[data-bundle-savings]');
          if (savingsElement) {
            // [percent] is the discount on the one discounted icon, rounded down.
            const isIconPair = selected.length === 2 && selected.every((item) => !item.tierTable);
            const text =
              isIconPair && savings > 0
                ? this.dataset.percentSavingsText.replace(
                    '[percent]',
                    Math.floor((savings / selected[0].variant.price) * 100)
                  )
                : this.savingsText(savings, tierSavings, tierItem);
            savingsElement.textContent = text;
            savingsElement.hidden = !text;
          }

          const [current] = this.items;
          const canAdd = current && current.variant.available;
          this.button.disabled = !canAdd;
          this.querySelector('[data-bundle-label]').textContent = canAdd
            ? `${this.dataset.addLabel} — ${this.formatMoney(total)}`
            : this.dataset.soldOut;
          const totalCompare = this.querySelector('[data-bundle-total-compare]');
          totalCompare.textContent = this.formatMoney(compareTotal);
          totalCompare.hidden = !canAdd || savings <= 0;
        }

        savingsText(savings, tierSavings, tierItem) {
          if (tierItem && this.hasAttribute('data-detailed-savings')) {
            let text = tierItem.free
              ? this.dataset.freeItemText.replace('[item]', tierItem.name)
              : this.dataset.discountedItemText
                  .replace('[item]', tierItem.name)
                  .replace('[amount]', this.formatMoney(tierSavings));
            const iconSavings = savings - tierSavings;
            if (iconSavings > 0) {
              text += ` ${this.dataset.iconSavingsText.replace('[amount]', this.formatMoney(iconSavings))}`;
            }
            return text;
          }
          return savings > 0 ? `${this.dataset.savingsLabel} ${this.formatMoney(savings)}` : '';
        }

        formatMoney(cents) {
          const format = this.dataset.moneyFormat;
          if (!format) return (cents / 100).toFixed(2);
          const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
          const placeholder = match ? match[1] : 'amount';
          const withDelimiters = (decimals, thousands, decimal) => {
            const [whole, fraction] = (cents / 100).toFixed(decimals).split('.');
            const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return fraction && Number(fraction) !== 0 ? `${grouped}${decimal}${fraction}` : grouped;
          };
          const formatters = {
            amount: () => withDelimiters(2, ',', '.'),
            amount_no_decimals: () => withDelimiters(0, ',', '.'),
            amount_with_comma_separator: () => withDelimiters(2, '.', ','),
            amount_no_decimals_with_comma_separator: () => withDelimiters(0, '.', ','),
            amount_with_apostrophe_separator: () => withDelimiters(2, "'", '.'),
            amount_with_space_separator: () => withDelimiters(2, ' ', ','),
          };
          const value = (formatters[placeholder] || formatters.amount)();
          return format.replace(/\{\{\s*\w+\s*\}\}/, value);
        }

        async addToCart() {
          const selected = this.items.filter((item) => item.input.checked && item.variant.available);
          if (!selected.length) return;

          const bundleId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
          const lead = selected.find((item) => !item.tierTable);
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const body = {
            items: selected.map((item) => {
              const properties =
                selected.length > 1 ? { _harmony_bundle: item === lead ? `${bundleId}:lead` : bundleId } : {};
              return { id: item.variant.id, quantity: 1, properties };
            }),
          };
          if (cart) {
            body.sections = cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            cart.setActiveElement(document.activeElement);
          }

          const error = this.querySelector('[data-bundle-error]');
          error.hidden = true;
          this.button.disabled = true;
          this.button.classList.add('loading');
          this.button.querySelector('.loading__spinner')?.classList.remove('hidden');

          try {
            const response = await fetch(window.routes.cart_add_url, {
              ...fetchConfig('javascript'),
              body: JSON.stringify(body),
            }).then((res) => res.json());

            if (response.status) {
              error.textContent = response.description || response.message;
              error.hidden = false;
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'uv-bundle', cartData: response });
            }
            cart.renderContents({ ...response.items[0], sections: response.sections });
            cart.classList.remove('is-empty');
          } catch (e) {
            console.error(e);
          } finally {
            this.button.classList.remove('loading');
            this.button.querySelector('.loading__spinner')?.classList.add('hidden');
            this.update();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uv-icon-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uv-icon-product')) {
    customElements.define(
      'uv-icon-product',
      class UvIconProduct extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.idInput = this.form.querySelector('[name="id"]');
          this.label = this.querySelector('[data-uv-label]');
          this.compare = this.querySelector('[data-uv-compare]');
          this.labelWrap = this.querySelector('.uv-atc__label');
          this.button = this.querySelector('[name="add"]');
          this.errorBox = this.querySelector('.product-form__error-message-wrapper');
          this.errorMessage = this.querySelector('.product-form__error-message');
          this.variants = JSON.parse(this.querySelector('[data-uv-variants]').textContent);
          this.optionNames = this.readJson('[data-uv-option-names]', []);
          this.optionRules = this.readJson('[data-uv-option-rules]', []);
          this.conditionalVariants = this.hasAttribute('data-conditional-variants');
          this.bundlePicker = this.hasAttribute('data-bundle-picker');
          this.iconsRequired = Number(this.dataset.iconsRequired || 0);
          this.previewingIcon = false;
          this._applyingConstraints = false;
          this.shownMediaId = '';

          this.addEventListener('change', (event) => {
            if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
            const label = event.target.closest('.uv-swatch');
            if (this.isUnavailableSwatch(label)) {
              event.target.checked = false;
              this.showUnavailableTip(label);
              return;
            }
            this.onOptionChange();
          });
          this.initThumbs();
          this.initUnavailableTips();
          if (this.bundlePicker) this.initBundlePicker();
          this.applyOptionConstraints();
          this.syncVariantFromOptions({ skipHistory: true, instantGallery: true });
        }

        readJson(selector, fallback) {
          const el = this.querySelector(selector);
          if (!el) return fallback;
          try {
            return JSON.parse(el.textContent);
          } catch (error) {
            return fallback;
          }
        }

        optionFieldsets() {
          return Array.from(this.querySelectorAll('fieldset.uv-options'));
        }

        normalizeToken(value) {
          return String(value || '')
            .trim()
            .toLowerCase()
            .replace(/\s+/g, ' ');
        }

        parseValueList(raw) {
          return String(raw || '')
            .split(',')
            .map((part) => this.normalizeToken(part))
            .filter(Boolean);
        }

        optionIndexByName(name) {
          const needle = this.normalizeToken(name);
          if (!needle) return -1;
          return this.optionNames.findIndex((option) => this.normalizeToken(option) === needle);
        }

        valueMatchesList(value, list) {
          const normalized = this.normalizeToken(value);
          return list.some((item) => item === normalized);
        }

        selectedOptions() {
          return this.optionFieldsets().map((fieldset) => {
            return fieldset.querySelector('input[type="radio"]:checked')?.value;
          });
        }

        setOptionValue(optionIndex, value) {
          const fieldset = this.optionFieldsets()[optionIndex];
          if (!fieldset || value == null) return;
          const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
            (radio) => radio.value === value
          );
          if (input) input.checked = true;
        }

        ruleMatches(rule, selected) {
          const index1 = this.optionIndexByName(rule.whenOption);
          if (index1 < 0) return false;
          const values1 = this.parseValueList(rule.whenValues);
          if (!values1.length || !this.valueMatchesList(selected[index1], values1)) return false;

          if (rule.whenOption2 && String(rule.whenOption2).trim()) {
            const index2 = this.optionIndexByName(rule.whenOption2);
            if (index2 < 0) return false;
            const values2 = this.parseValueList(rule.whenValues2);
            if (!values2.length || !this.valueMatchesList(selected[index2], values2)) return false;
          }

          return true;
        }

        optionsHiddenByRules(selected) {
          const hidden = new Set();
          const hideValues = new Map();

          this.optionRules.forEach((rule) => {
            if (!this.ruleMatches(rule, selected)) return;
            const targetIndex = this.optionIndexByName(rule.hideOption);
            if (targetIndex < 0) return;

            const specific = this.parseValueList(rule.hideValues);
            if (specific.length) {
              const current = hideValues.get(targetIndex) || new Set();
              specific.forEach((value) => current.add(value));
              hideValues.set(targetIndex, current);
            } else {
              hidden.add(targetIndex);
            }
          });

          return { hidden, hideValues };
        }

        optionValueLabel(optionIndex, value) {
          const fieldset = this.optionFieldsets()[optionIndex];
          if (!fieldset || value == null) return value || '';
          const match = Array.from(fieldset.querySelectorAll('.uv-swatch')).find((label) => {
            const input = label.querySelector('input[type="radio"]');
            return input && input.value === value;
          });
          const text = match?.querySelector('.uv-swatch__label')?.textContent?.trim();
          return text || value;
        }

        conflictLabels(optionIndex, value, selected, unconstrained) {
          const others = selected
            .map((sel, index) => ({ sel, index }))
            .filter(
              ({ sel, index }) =>
                index !== optionIndex && !unconstrained.has(index) && sel != null && sel !== ''
            );
          const withValue = this.variants.filter((variant) => variant.options[optionIndex] === value);
          const blockers = others
            .filter(({ sel, index }) => !withValue.some((variant) => variant.options[index] === sel))
            .map(({ sel, index }) => this.optionValueLabel(index, sel));
          if (blockers.length) return blockers;
          return others.map(({ sel, index }) => this.optionValueLabel(index, sel));
        }

        ruleConflictLabels(optionIndex, value, selected) {
          const labels = [];
          this.optionRules.forEach((rule) => {
            if (!this.ruleMatches(rule, selected)) return;
            const targetIndex = this.optionIndexByName(rule.hideOption);
            if (targetIndex !== optionIndex) return;
            const specific = this.parseValueList(rule.hideValues);
            if (specific.length && !this.valueMatchesList(value, specific)) return;

            const index1 = this.optionIndexByName(rule.whenOption);
            if (index1 >= 0 && selected[index1]) {
              labels.push(this.optionValueLabel(index1, selected[index1]));
            }
            if (rule.whenOption2 && String(rule.whenOption2).trim()) {
              const index2 = this.optionIndexByName(rule.whenOption2);
              if (index2 >= 0 && selected[index2]) {
                labels.push(this.optionValueLabel(index2, selected[index2]));
              }
            }
          });
          return [...new Set(labels.filter(Boolean))];
        }

        formatUnavailableMessage(conflicts) {
          const template =
            this.dataset.unavailableWith || 'Not available with __OPTION__';
          const option = conflicts.filter(Boolean).join(', ') || 'this selection';
          return template.replace('__OPTION__', option);
        }

        ensureUnavailableMessage(label, message) {
          label.dataset.uvUnavailableMsg = message;
          label.setAttribute('aria-description', message);
        }

        clearUnavailableMessage(label) {
          delete label.dataset.uvUnavailableMsg;
          label.removeAttribute('aria-description');
          if (this._tipAnchor === label) this.hideUnavailableTip();
        }

        isUnavailableSwatch(label) {
          return Boolean(label?.classList.contains('is-unavailable'));
        }

        setSwatchAvailability(label, input, available, reasonConflicts) {
          label.hidden = false;
          label.classList.remove('is-fading');
          clearTimeout(label._uvFadeTimer);

          // Keep the radio enabled so mobile taps on the label still fire.
          input.disabled = false;

          if (available) {
            label.classList.remove('is-unavailable');
            label.removeAttribute('aria-disabled');
            label.removeAttribute('tabindex');
            this.clearUnavailableMessage(label);
            return;
          }

          if (input.checked) input.checked = false;
          label.classList.add('is-unavailable');
          label.setAttribute('aria-disabled', 'true');
          label.setAttribute('tabindex', '0');
          this.ensureUnavailableMessage(
            label,
            this.formatUnavailableMessage(reasonConflicts || [])
          );
        }

        getUnavailableTipEl() {
          if (this._tipEl && this._tipEl.isConnected) return this._tipEl;
          const tip = document.createElement('div');
          tip.className = 'uv-unavailable-tip';
          tip.setAttribute('role', 'status');
          tip.setAttribute('aria-live', 'polite');
          document.body.appendChild(tip);
          this._tipEl = tip;
          return tip;
        }

        hideUnavailableTip() {
          clearTimeout(this._tipTimer);
          this._tipAnchor = null;
          const tip = this._tipEl;
          if (!tip) return;
          tip.classList.remove('is-open', 'is-below', 'is-instant');
        }

        positionUnavailableTip(label) {
          const tip = this.getUnavailableTipEl();
          const rect = label.getBoundingClientRect();
          const tipHeight = tip.offsetHeight || 40;
          const tipWidth = tip.offsetWidth || 160;
          const gap = 10;
          const placeBelow = rect.top < tipHeight + gap + 8;
          const rawLeft = rect.left + rect.width / 2;
          const left = Math.min(
            Math.max(rawLeft, 12 + tipWidth / 2),
            window.innerWidth - 12 - tipWidth / 2
          );

          tip.classList.toggle('is-below', placeBelow);
          tip.style.left = `${left}px`;
          tip.style.top = placeBelow
            ? `${rect.bottom + gap}px`
            : `${rect.top - gap - tipHeight}px`;
        }

        initUnavailableTips() {
          let lastTouchAt = 0;

          const onActivate = (event) => {
            const label = event.target.closest?.('.uv-swatch.is-unavailable');
            if (!label || !this.contains(label)) return;

            // Ignore the synthetic click that follows touchend.
            if (event.type === 'click' && Date.now() - lastTouchAt < 500) {
              event.preventDefault();
              event.stopPropagation();
              return;
            }
            if (event.type === 'touchend') lastTouchAt = Date.now();

            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
              event.stopImmediatePropagation();
            }
            const input = label.querySelector('input[type="radio"]');
            if (input) input.checked = false;
            this.showUnavailableTip(label, { autoHide: true });
          };

          this.addEventListener('click', onActivate, true);
          this.addEventListener('touchend', onActivate, { capture: true, passive: false });

          this.addEventListener('pointerover', (event) => {
            if (window.matchMedia('(hover: hover)').matches === false) return;
            const label = event.target.closest?.('.uv-swatch.is-unavailable');
            if (!label || !this.contains(label)) return;
            this.showUnavailableTip(label, { autoHide: false });
          });

          this.addEventListener('pointerout', (event) => {
            const label = event.target.closest?.('.uv-swatch.is-unavailable');
            if (!label || !this.contains(label)) return;
            const next = event.relatedTarget;
            if (next && label.contains(next)) return;
            if (this._tipAnchor === label) this.hideUnavailableTip();
          });

          this.addEventListener(
            'keydown',
            (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              const label = event.target.closest?.('.uv-swatch.is-unavailable');
              if (!label || !this.contains(label)) return;
              event.preventDefault();
              this.showUnavailableTip(label, { autoHide: true });
            },
            true
          );

          // Don't drag the tip while scrolling — dismiss it immediately.
          this._onTipScrollHide = () => {
            if (this._tipAnchor) this.hideUnavailableTip();
          };
          window.addEventListener('scroll', this._onTipScrollHide, { capture: true, passive: true });
          window.addEventListener('resize', this._onTipScrollHide, { passive: true });
        }

        showUnavailableTip(label, options = {}) {
          const message = label.dataset.uvUnavailableMsg;
          if (!message) return;

          const tip = this.getUnavailableTipEl();
          const autoHide = options.autoHide !== false;
          tip.textContent = message;
          this._tipAnchor = label;

          tip.classList.add('is-instant');
          tip.classList.remove('is-open');
          this.positionUnavailableTip(label);
          tip.classList.add('is-open');
          // Keep the open state snappy; only fade on hide.
          requestAnimationFrame(() => {
            tip.classList.remove('is-instant');
          });

          clearTimeout(this._tipTimer);
          if (!autoHide) return;
          const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const holdMs = prefersReduced ? 3200 : 2800;
          this._tipTimer = setTimeout(() => this.hideUnavailableTip(), holdMs);
        }

        valuePossible(optionIndex, value, selected, unconstrained) {
          return this.variants.some((variant) => {
            if (variant.options[optionIndex] !== value) return false;
            return variant.options.every((option, index) => {
              if (index === optionIndex) return true;
              if (unconstrained.has(index)) return true;
              if (selected[index] == null || selected[index] === '') return true;
              return option === selected[index];
            });
          });
        }

        pickVariantForSelection(selected, unconstrained) {
          const matches = this.variants.filter((variant) =>
            variant.options.every((option, index) => {
              if (unconstrained.has(index)) return true;
              if (selected[index] == null || selected[index] === '') return true;
              return option === selected[index];
            })
          );
          return matches.find((variant) => variant.available) || matches[0] || null;
        }

        paintOptionAvailability(fieldsets) {
          const selected = this.selectedOptions();
          const { hidden: ruleHidden, hideValues } = this.optionsHiddenByRules(selected);
          const unconstrained = new Set(ruleHidden);

          fieldsets.forEach((fieldset, index) => {
            const forceHide = ruleHidden.has(index);
            fieldset.hidden = forceHide;

            const blockedValues = hideValues.get(index) || new Set();
            const labels = Array.from(fieldset.querySelectorAll('.uv-swatch'));

            labels.forEach((label) => {
              const input = label.querySelector('input[type="radio"]');
              if (!input) return;
              const blockedByRule = blockedValues.has(this.normalizeToken(input.value));
              const possible =
                !this.conditionalVariants ||
                forceHide ||
                this.valuePossible(index, input.value, selected, unconstrained);
              const available = forceHide || (!blockedByRule && possible);
              let conflicts = [];
              if (!available) {
                conflicts = blockedByRule
                  ? this.ruleConflictLabels(index, input.value, selected)
                  : this.conflictLabels(index, input.value, selected, unconstrained);
                if (!conflicts.length) {
                  conflicts = this.conflictLabels(index, input.value, selected, unconstrained);
                }
              }
              this.setSwatchAvailability(label, input, available, conflicts);
            });

            if (forceHide) return;

            const checked = fieldset.querySelector('input[type="radio"]:checked');
            const checkedLabel = checked?.closest('.uv-swatch');
            if (!checked || this.isUnavailableSwatch(checkedLabel)) {
              const first = Array.from(fieldset.querySelectorAll('.uv-swatch')).find(
                (swatch) => !this.isUnavailableSwatch(swatch)
              );
              const firstInput = first?.querySelector('input[type="radio"]');
              if (firstInput) firstInput.checked = true;
            }
          });

          return { ruleHidden, unconstrained };
        }

        applyOptionConstraints() {
          if (!this.conditionalVariants && !this.optionRules.length) return;

          this._applyingConstraints = true;
          try {
            const fieldsets = this.optionFieldsets();
            let { ruleHidden, unconstrained } = this.paintOptionAvailability(fieldsets);
            ({ ruleHidden, unconstrained } = this.paintOptionAvailability(fieldsets));

            const match = this.pickVariantForSelection(this.selectedOptions(), unconstrained);
            if (match) {
              unconstrained.forEach((index) => {
                this.setOptionValue(index, match.options[index]);
              });
            }
          } finally {
            this._applyingConstraints = false;
          }
        }

        initBundlePicker() {
          const iconsJson = this.querySelector('[data-uv-bundle-icons]');
          const giftJson = this.querySelector('[data-uv-bundle-gift]');
          this.bundleIcons = iconsJson ? JSON.parse(iconsJson.textContent) : [];
          this.bundleGift = giftJson ? JSON.parse(giftJson.textContent) : null;
          this.selectedIds = new Set();
          this.selectionOrder = [];
          this.mosaicUnlocked = false;
          this.mosaicSlideIndex = this.slides.findIndex((slide) => slide.hasAttribute('data-uv-bundle-mosaic'));
          this.firstProductSlideIndex = this.slides.findIndex(
            (slide) =>
              !slide.hasAttribute('data-uv-bundle-mosaic') &&
              !slide.classList.contains('is-variant-only') &&
              !slide.hasAttribute('hidden')
          );

          this.querySelectorAll('[data-bundle-icon]').forEach((el) => {
            const id = Number(el.dataset.productId);
            if (el.classList.contains('is-selected')) {
              this.selectedIds.add(id);
              this.selectionOrder.push(id);
            }
            el.addEventListener('click', () => this.toggleIcon(id));
          });

          this.button?.addEventListener('click', () => this.addBundleToCart());
          this.syncBundleUi();
          this.updateBundleMosaic();
          this.showFirstBundleImage({ instant: true });
        }

        showFirstBundleImage(options = {}) {
          const index = this.firstProductSlideIndex >= 0 ? this.firstProductSlideIndex : 0;
          this.showSlide(index, { instant: Boolean(options.instant), fade: false });
        }

        mosaicContainers() {
          return Array.from(this.querySelectorAll('[data-uv-bundle-mosaic] .uv-bundle-mosaic, [data-uv-mosaic-thumb] .uv-bundle-mosaic'));
        }

        iconImageForMosaic(icon, options) {
          if (!icon) return null;
          const variant = this.matchingIconVariant(icon, options);
          return icon.featuredImage || variant?.image || null;
        }

        setMosaicCell(cell, src, alt) {
          if (!cell) return;
          const isThumb = cell.tagName === 'SPAN';
          if (isThumb) {
            if (src) {
              cell.style.backgroundImage = `url(${src})`;
              cell.classList.remove('is-empty');
            } else {
              cell.style.backgroundImage = '';
              cell.classList.add('is-empty');
            }
            return;
          }

          let img = cell.querySelector('img');
          if (!img) {
            img = document.createElement('img');
            img.alt = '';
            img.width = 800;
            img.height = 800;
            img.decoding = 'async';
            cell.appendChild(img);
          }

          if (!src) {
            img.hidden = true;
            img.removeAttribute('src');
            img.alt = '';
            cell.classList.add('is-empty');
            return;
          }

          const apply = () => {
            img.alt = alt || '';
            img.src = src;
            img.hidden = false;
            cell.classList.remove('is-empty');
            cell.classList.remove('is-fading');
          };

          if (img.getAttribute('src') === src) {
            apply();
            return;
          }

          cell.classList.add('is-fading');
          clearTimeout(cell._mosaicFade);
          cell._mosaicFade = setTimeout(apply, 160);
        }

        updateBundleMosaic() {
          if (!this.bundlePicker || this.mosaicSlideIndex < 0) return;

          const options = this.selectedOptions();
          const slots = this.selectionOrder.slice(0, this.iconsRequired).map((id) => {
            const icon = this.bundleIcons.find((item) => item.id === id);
            return {
              src: this.iconImageForMosaic(icon, options),
              alt: icon?.title?.split('|')[0]?.trim() || '',
            };
          });

          while (slots.length < this.iconsRequired) {
            slots.push({ src: null, alt: '' });
          }

          const giftSrc = this.bundleGift?.featuredImage || null;
          const giftAlt = this.bundleGift?.title?.split('|')[0]?.trim() || '';

          this.mosaicContainers().forEach((mosaic) => {
            for (let index = 0; index < this.iconsRequired; index += 1) {
              const cell = mosaic.querySelector(`[data-mosaic-slot="${index}"]`);
              this.setMosaicCell(cell, slots[index]?.src, slots[index]?.alt);
            }
            const giftCell = mosaic.querySelector('[data-mosaic-gift]');
            this.setMosaicCell(giftCell, giftSrc, giftAlt);
          });
        }

        showBundleMosaic(options = {}) {
          this.updateBundleMosaic();
          if (this.mosaicSlideIndex < 0) return;
          this.showSlide(this.mosaicSlideIndex, {
            instant: Boolean(options.instant),
            fade: options.fade !== false && !options.instant,
          });
        }

        currentBundleVariant() {
          const selected = this.selectedOptions();
          return this.variants.find((item) => item.options.every((option, index) => option === selected[index]));
        }

        goldLeafKey(value) {
          const text = this.normalizeToken(value);
          if (!text) return '';
          if (/(?:^|[^a-z0-9])24\s*k|real\s*gold|solid\s*gold/.test(text) || text.includes('24k')) return '24k';
          if (text.includes('imitation')) return 'imitation';
          if (
            text.includes('no gold') ||
            text.includes('no gild') ||
            text.includes('without gold') ||
            text === 'none' ||
            text === 'no' ||
            text.includes('ungilded')
          ) {
            return 'none';
          }
          return text;
        }

        iconOptionIndex(icon, needles) {
          const names = (icon.optionNames || []).map((name) => this.normalizeToken(name));
          return names.findIndex((name) => needles.some((needle) => name.includes(needle)));
        }

        gildingOptionIndex(icon) {
          const named = this.iconOptionIndex(icon, ['gild', 'gold', 'leaf']);
          if (named >= 0) return named;

          const sample = icon.variants?.[0]?.options || [];
          for (let index = sample.length - 1; index >= 0; index -= 1) {
            if (this.goldLeafKey(sample[index])) return index;
          }
          return sample.length ? sample.length - 1 : 0;
        }

        preferredBundleVariant(variant, icon) {
          if (!variant) return false;
          const sizeIndex = this.iconOptionIndex(icon, ['size']);
          const finishIndex = this.iconOptionIndex(icon, ['finish', 'texture', 'style', 'relief']);
          const size = sizeIndex >= 0 ? this.normalizeToken(variant.options?.[sizeIndex]) : '';
          const finish = finishIndex >= 0 ? this.normalizeToken(variant.options?.[finishIndex]) : '';
          const sizeOk = !size || /5\s*[x×]\s*7/.test(size) || size.includes('5"x7') || size.includes('5”x7');
          const finishOk = !finish || finish.includes('3d') || finish.includes('3-d');
          return sizeOk && finishOk;
        }

        matchingIconVariant(icon, options) {
          if (!icon?.variants?.length) return null;

          const selectedGold = this.goldLeafKey(options?.[0]);
          const gildingIndex = this.gildingOptionIndex(icon);
          const available = icon.variants.filter((variant) => variant.available);
          const pool = available.length ? available : icon.variants;

          const goldMatches = selectedGold
            ? pool.filter((variant) => this.goldLeafKey(variant.options?.[gildingIndex]) === selectedGold)
            : pool;

          const preferred = goldMatches.filter((variant) => this.preferredBundleVariant(variant, icon));
          return (
            preferred[0] ||
            goldMatches[0] ||
            pool.find((variant) => this.preferredBundleVariant(variant, icon)) ||
            pool[0] ||
            null
          );
        }

        matchingGiftVariant(options) {
          if (!this.bundleGift?.variants?.length) return null;
          const selectedGold = this.goldLeafKey(options?.[0]);
          const available = this.bundleGift.variants.filter((variant) => variant.available);
          const pool = available.length ? available : this.bundleGift.variants;

          if (!selectedGold) return pool[0] || null;

          const gildingIndex = this.gildingOptionIndex(this.bundleGift);
          return (
            pool.find((variant) => this.goldLeafKey(variant.options?.[gildingIndex]) === selectedGold) ||
            pool.find((variant) => variant.options?.some((option) => this.goldLeafKey(option) === selectedGold)) ||
            pool[0] ||
            null
          );
        }

        referencePrice(options) {
          for (const id of this.selectionOrder) {
            const icon = this.bundleIcons.find((item) => item.id === id);
            const variant = this.matchingIconVariant(icon, options);
            if (variant) return variant.price;
          }
          for (const icon of this.bundleIcons) {
            const variant = this.matchingIconVariant(icon, options);
            if (variant) return variant.price;
          }
          return null;
        }

        selectedCount() {
          return this.selectedIds.size;
        }

        toggleIcon(productId) {
          const options = this.selectedOptions();
          const icon = this.bundleIcons.find((item) => item.id === productId);
          const variant = this.matchingIconVariant(icon, options);
          const reference = this.referencePrice(options);
          if (!variant || (reference != null && variant.price !== reference)) return;

          if (this.selectedIds.has(productId)) {
            this.selectedIds.delete(productId);
            this.selectionOrder = this.selectionOrder.filter((id) => id !== productId);
          } else {
            if (this.selectedIds.size >= this.iconsRequired && this.selectionOrder.length) {
              const removed = this.selectionOrder.pop();
              this.selectedIds.delete(removed);
            }
            this.selectedIds.add(productId);
            this.selectionOrder.push(productId);
          }

          this.mosaicUnlocked = true;
          this.syncBundleUi();
          this.showBundleMosaic();
        }

        fadeGallery(update) {
          if (!this.gallery) {
            update();
            return;
          }
          this.gallery.classList.add('is-fading');
          clearTimeout(this.galleryFadeTimer);
          this.galleryFadeTimer = setTimeout(() => {
            update();
            requestAnimationFrame(() => {
              requestAnimationFrame(() => this.gallery.classList.remove('is-fading'));
            });
          }, 180);
        }

        fadeButtonLabel(update) {
          if (!this.labelWrap) {
            update();
            return;
          }
          this.labelWrap.classList.add('is-fading');
          clearTimeout(this.labelFadeTimer);
          this.labelFadeTimer = setTimeout(() => {
            update();
            requestAnimationFrame(() => this.labelWrap.classList.remove('is-fading'));
          }, 160);
        }

        showIconPreview(productId, src) {
          if (!this.gallery) return;
          const slideIndex = this.slides.findIndex(
            (slide) =>
              slide.dataset.bundleProductId === String(productId) &&
              slide.hasAttribute('data-bundle-product-primary')
          );
          const fallbackIndex = this.slides.findIndex(
            (slide) => slide.dataset.bundleProductId === String(productId)
          );
          const index = slideIndex >= 0 ? slideIndex : fallbackIndex;

          this.fadeGallery(() => {
            if (index >= 0) {
              const img = this.slides[index].querySelector('img');
              if (img && src) {
                if (!img.dataset.originalSrc) {
                  img.dataset.originalSrc = img.getAttribute('src') || '';
                  img.dataset.originalSrcset = img.getAttribute('srcset') || '';
                }
                img.removeAttribute('srcset');
                img.src = src;
              }
              this.previewingIcon = true;
              this.showSlide(index, { fade: false, instant: true });
              return;
            }

            if (!src) return;
            const slide = this.slides[0];
            const img = slide?.querySelector('img');
            if (!img) return;
            if (!this.previewingIcon) {
              this.originalGallerySrc = img.currentSrc || img.src;
              this.originalGallerySrcset = img.getAttribute('srcset');
            }
            this.previewingIcon = true;
            img.removeAttribute('srcset');
            img.src = src;
            this.showSlide(0, { fade: false, instant: true });
          });
        }

        restoreIconPreviewImages() {
          if (!this.previewingIcon) return;
          this.slides.forEach((slide) => {
            const img = slide.querySelector('img');
            if (!img?.dataset.originalSrc) return;
            img.src = img.dataset.originalSrc;
            if (img.dataset.originalSrcset) {
              img.setAttribute('srcset', img.dataset.originalSrcset);
            } else {
              img.removeAttribute('srcset');
            }
            delete img.dataset.originalSrc;
            delete img.dataset.originalSrcset;
          });
          if (this.originalGallerySrc) {
            const img = this.slides[0]?.querySelector('img');
            if (img) {
              img.src = this.originalGallerySrc;
              if (this.originalGallerySrcset) img.setAttribute('srcset', this.originalGallerySrcset);
            }
          }
          this.previewingIcon = false;
          this.originalGallerySrc = undefined;
          this.originalGallerySrcset = undefined;
        }

        clearIconPreview() {
          if (!this.previewingIcon) return;
          this.fadeGallery(() => this.restoreIconPreviewImages());
        }

        syncBundleUi() {
          if (!this.bundlePicker || !this.selectedIds) return;

          const options = this.selectedOptions();
          let reference = this.referencePrice(options);

          [...this.selectedIds].forEach((id) => {
            const icon = this.bundleIcons.find((item) => item.id === id);
            const variant = this.matchingIconVariant(icon, options);
            if (!variant || (reference != null && variant.price !== reference)) {
              this.selectedIds.delete(id);
              this.selectionOrder = this.selectionOrder.filter((item) => item !== id);
            }
          });

          reference = this.referencePrice(options);
          const total = this.selectedCount();
          const remaining = Math.max(0, this.iconsRequired - total);

          this.querySelectorAll('[data-bundle-icon]').forEach((el) => {
            const id = Number(el.dataset.productId);
            const selected = this.selectedIds.has(id);
            const icon = this.bundleIcons.find((item) => item.id === id);
            const variant = this.matchingIconVariant(icon, options);
            const priceMismatch = !variant || (reference != null && variant.price !== reference);

            el.classList.toggle('is-selected', selected);
            el.classList.toggle('is-disabled', priceMismatch);
            el.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          const variant = this.currentBundleVariant();
          const canAdd = Boolean(variant?.available && remaining === 0 && this.bundleGift);
          this.button.disabled = !canAdd;

          let nextLabel = this.dataset.soldOut;
          let nextCompare = '';
          let showCompare = false;

          if (variant?.available) {
            if (remaining > 0) {
              nextLabel = this.dataset.selectMore.replace('COUNT', String(remaining));
            } else {
              nextLabel = this.dataset.addLabel.replace('__PRICE__', variant.price);
              if (variant.compareAt) {
                nextCompare = variant.compareAt;
                showCompare = true;
              }
            }
          }

          const labelChanged = this.label.textContent !== nextLabel;
          const compareChanged =
            Boolean(this.compare) &&
            (this.compare.hidden === showCompare || this.compare.textContent !== nextCompare);

          const applyLabel = () => {
            this.label.textContent = nextLabel;
            if (this.compare) {
              this.compare.textContent = nextCompare;
              this.compare.hidden = !showCompare;
            }
          };

          if (labelChanged || compareChanged) {
            this.fadeButtonLabel(applyLabel);
          } else {
            applyLabel();
          }

          this.updateBundleMosaic();
        }

        async addBundleToCart() {
          if (this.button.disabled) return;
          const options = this.selectedOptions();
          const giftVariant = this.matchingGiftVariant(options);
          if (!giftVariant?.available) return;

          const packageId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
          const items = [];
          let leadSet = false;

          this.selectionOrder.forEach((id) => {
            const icon = this.bundleIcons.find((item) => item.id === id);
            if (!icon) return;
            const variant = this.matchingIconVariant(icon, options);
            if (!variant?.available) return;
            const properties = { _harmony_bundle: leadSet ? `pkg:${packageId}` : `pkg:${packageId}:lead` };
            leadSet = true;
            items.push({ id: variant.id, quantity: 1, properties });
          });

          if (!items.length || items.reduce((sum, item) => sum + item.quantity, 0) !== this.iconsRequired) return;

          items.push({
            id: giftVariant.id,
            quantity: 1,
            properties: { _harmony_bundle: `pkg:${packageId}:gift` },
          });

          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const body = { items };
          if (cart) {
            body.sections = cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            cart.setActiveElement(document.activeElement);
          }

          this.handleBundleError();
          this.button.disabled = true;
          this.button.classList.add('loading');
          this.button.querySelector('.loading__spinner')?.classList.remove('hidden');

          try {
            const response = await fetch(window.routes.cart_add_url, {
              ...fetchConfig('javascript'),
              body: JSON.stringify(body),
            }).then((res) => res.json());

            if (response.status) {
              this.handleBundleError(response.description || response.message);
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'uv-icon-bundle', cartData: response });
            }
            cart.renderContents({ ...response.items[0], sections: response.sections });
            cart.classList.remove('is-empty');
          } catch (error) {
            console.error(error);
            this.handleBundleError(error.message);
          } finally {
            this.button.classList.remove('loading');
            this.button.querySelector('.loading__spinner')?.classList.add('hidden');
            this.syncBundleUi();
          }
        }

        handleBundleError(message) {
          if (!this.errorBox || !this.errorMessage) return;
          if (!message) {
            this.errorBox.hidden = true;
            this.errorMessage.textContent = '';
            return;
          }
          this.errorBox.hidden = false;
          this.errorMessage.textContent = message;
        }

        slideForVariant(variant) {
          if (!variant.mediaId) return -1;
          return this.slides.findIndex((slide) => slide.id.endsWith(`-${variant.mediaId}`));
        }

        rememberPrimaryImage() {
          const img = this.slides[0]?.querySelector('img');
          if (!img || img.dataset.originalSrc) return;
          img.dataset.originalSrc = img.getAttribute('src') || '';
          img.dataset.originalSrcset = img.getAttribute('srcset') || '';
          img.dataset.shownSrc = img.currentSrc || img.getAttribute('src') || '';
          const thumbImg = this.thumbs[0]?.querySelector('img');
          if (thumbImg && !thumbImg.dataset.originalSrc) {
            thumbImg.dataset.originalSrc = thumbImg.getAttribute('src') || '';
          }
        }

        applyVariantImage(variant, options = {}) {
          if (!this.gallery || !this.slides.length) return;
          this.rememberPrimaryImage();
          const img = this.slides[0].querySelector('img');
          if (!img) return;

          const slideIndex = this.slideForVariant(variant);
          const originalMediaId = this.slides[0].id.split('-').pop();
          const nextMediaId = slideIndex > 0 ? String(variant.mediaId) : originalMediaId;
          let src = img.dataset.originalSrc;
          let srcset = img.dataset.originalSrcset || '';
          let thumbSrc = this.thumbs[0]?.querySelector('img')?.dataset.originalSrc || '';

          if (slideIndex > 0) {
            const variantImg = this.slides[slideIndex].querySelector('img');
            const variantThumb = this.thumbs[slideIndex]?.querySelector('img');
            if (variantImg) {
              src = variantImg.getAttribute('src') || variantImg.currentSrc || src;
              srcset = variantImg.getAttribute('srcset') || '';
            }
            if (variantThumb) thumbSrc = variantThumb.getAttribute('src') || thumbSrc;
          }

          const commit = () => {
            if (srcset) img.setAttribute('srcset', srcset);
            else img.removeAttribute('srcset');
            img.src = src;
            img.dataset.shownSrc = src;
            this.shownMediaId = nextMediaId;
            const thumbImg = this.thumbs[0]?.querySelector('img');
            if (thumbImg && thumbSrc) thumbImg.src = thumbSrc;
            this.showSlide(0, { instant: true });
          };

          if (this.shownMediaId === nextMediaId) {
            this.showSlide(0, { instant: true });
            return;
          }

          if (options.instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            commit();
            return;
          }

          this.crossfadePrimary(img, src, srcset, commit);
        }

        crossfadePrimary(img, src, srcset, commit) {
          const slide = this.slides[0];
          slide.querySelectorAll('.uv-gallery__incoming').forEach((node) => node.remove());
          const incoming = document.createElement('img');
          incoming.className = 'uv-gallery__incoming';
          incoming.alt = img.alt || '';
          if (srcset) incoming.setAttribute('srcset', srcset);
          incoming.src = src;
          let finished = false;
          const finish = () => {
            if (finished) return;
            finished = true;
            commit();
            incoming.remove();
          };
          incoming.addEventListener('transitionend', (event) => {
            if (event.propertyName === 'opacity') finish();
          });
          slide.appendChild(incoming);
          this.showSlide(0, { instant: true });
          const reveal = () => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => incoming.classList.add('is-shown'));
            });
          };
          if (incoming.complete) reveal();
          else incoming.addEventListener('load', reveal, { once: true });
          incoming.addEventListener('error', finish, { once: true });
          setTimeout(finish, 1200);
        }

        initThumbs() {
          this.gallery = this.querySelector('.uv-gallery');
          this.slides = Array.from(this.gallery.children);
          this.thumbsRoot = this.querySelector('.uv-thumbs');
          this.thumbsViewport = this.querySelector('.uv-thumbs__viewport');
          this.thumbsTrack = this.querySelector('.uv-thumbs__track');
          this.thumbsPrev = this.querySelector('[data-uv-thumbs-prev]');
          this.thumbsNext = this.querySelector('[data-uv-thumbs-next]');
          this.thumbs = Array.from(this.querySelectorAll('[data-uv-thumb]'));
          if (this.thumbs.length === 0) return;

          this.currentSlide = 0;
          this.thumbsRoot?.addEventListener('click', (event) => {
            const thumb = event.target.closest('[data-uv-thumb]');
            if (thumb) this.showSlide(Number(thumb.dataset.uvThumb));
          });
          this.thumbsPrev?.addEventListener('click', () => this.scrollThumbsBy(-1));
          this.thumbsNext?.addEventListener('click', () => this.scrollThumbsBy(1));
          this.thumbsViewport?.addEventListener(
            'scroll',
            () => {
              clearTimeout(this.thumbsArrowTimer);
              this.thumbsArrowTimer = setTimeout(() => this.updateThumbsArrows(), 80);
            },
            { passive: true }
          );
          this.thumbsRoot?.addEventListener(
            'wheel',
            (event) => {
              if (!this.thumbsViewport) return;
              const max = this.thumbsViewport.scrollHeight - this.thumbsViewport.clientHeight;
              if (max <= 2) return;
              event.preventDefault();
              this.thumbsViewport.scrollTop += event.deltaY;
              this.updateThumbsArrows();
            },
            { passive: false }
          );

          let frame;
          this.gallery.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(frame);
              frame = requestAnimationFrame(() => {
                if (this.scrollTarget !== undefined) return;
                this.setActiveThumb(this.visibleSlide());
              });
            },
            { passive: true }
          );

          requestAnimationFrame(() => this.updateThumbsArrows());
        }

        thumbStep() {
          const thumb = this.thumbs.find((item) => !item.hidden && !item.classList.contains('is-variant-only'));
          if (!thumb || !this.thumbsTrack) return 46;
          const styles = getComputedStyle(this.thumbsTrack);
          const gap = Number.parseFloat(styles.rowGap || styles.gap || '6') || 6;
          return thumb.offsetHeight + gap;
        }

        scrollThumbsBy(direction) {
          if (!this.thumbsViewport) return;
          const step = this.thumbStep();
          this.thumbsViewport.scrollBy({
            top: direction * step,
            behavior: 'smooth',
          });
          clearTimeout(this.thumbsArrowTimer);
          this.thumbsArrowTimer = setTimeout(() => this.updateThumbsArrows(), 320);
        }

        updateThumbsArrows() {
          if (!this.thumbsViewport) return;
          const max = Math.max(0, this.thumbsViewport.scrollHeight - this.thumbsViewport.clientHeight);
          const top = this.thumbsViewport.scrollTop;
          const atStart = top <= 2;
          const atEnd = top >= max - 2;
          const canScroll = max > 2;

          if (this.thumbsPrev) {
            this.thumbsPrev.hidden = !canScroll || atStart;
            this.thumbsPrev.disabled = !canScroll || atStart;
          }
          if (this.thumbsNext) {
            this.thumbsNext.hidden = !canScroll || atEnd;
            this.thumbsNext.disabled = !canScroll || atEnd;
          }
        }

        slideOffset(index) {
          return this.slides[index].offsetLeft - this.slides[0].offsetLeft;
        }

        visibleSlide() {
          const left = this.gallery.scrollLeft;
          let closest = 0;
          this.slides.forEach((slide, index) => {
            if (slide.classList.contains('is-variant-only')) return;
            if (Math.abs(this.slideOffset(index) - left) < Math.abs(this.slideOffset(closest) - left)) {
              closest = index;
            }
          });
          return closest;
        }

        showSlide(index, options = {}) {
          const count = this.slides.length;
          if (!count) return;
          const target = (index + count) % count;
          const instant = Boolean(options.instant);
          const useFade = options.fade === true;

          const go = () => {
            this.scrollTarget = target;
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => {
              this.scrollTarget = undefined;
            }, instant ? 50 : 700);
            this.gallery.scrollTo({
              left: this.slideOffset(target),
              behavior: instant ? 'auto' : 'smooth',
            });
            this.setActiveThumb(target);
          };

          if (useFade) {
            this.fadeGallery(go);
            return;
          }
          go();
        }

        setActiveThumb(index) {
          if (this.thumbs.length === 0) return;
          if (index === this.currentSlide && this.thumbs[index].classList.contains('is-active')) return;
          this.currentSlide = index;
          this.thumbs.forEach((thumb, thumbIndex) => {
            const active = thumbIndex === index;
            thumb.classList.toggle('is-active', active);
            if (active) {
              thumb.setAttribute('aria-current', 'true');
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
          const thumb = this.thumbs[index];
          if (!thumb || !this.thumbsViewport) return;
          const targetTop = thumb.offsetTop - (this.thumbsViewport.clientHeight - thumb.offsetHeight) / 2;
          this.thumbsViewport.scrollTo({
            top: Math.max(0, targetTop),
            behavior: 'smooth',
          });
          clearTimeout(this.thumbsArrowTimer);
          this.thumbsArrowTimer = setTimeout(() => this.updateThumbsArrows(), 320);
        }

        onOptionChange() {
          if (this._applyingConstraints) return;
          this.applyOptionConstraints();
          this.syncVariantFromOptions();
        }

        syncVariantFromOptions(options = {}) {
          const selected = this.selectedOptions();
          let variant = this.variants.find((item) => {
            return item.options.every((option, index) => option === selected[index]);
          });

          if (!variant) {
            const hiddenIndexes = new Set();
            this.optionFieldsets().forEach((fieldset, index) => {
              if (fieldset.hidden) hiddenIndexes.add(index);
            });
            variant = this.pickVariantForSelection(selected, hiddenIndexes);
            if (variant) {
              hiddenIndexes.forEach((index) => this.setOptionValue(index, variant.options[index]));
            }
          }

          if (!variant) return;

          this.idInput.value = variant.id;
          this.idInput.disabled = !variant.available;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));

          const slideIndex = this.slideForVariant(variant);
          const targetSlide = slideIndex >= 0 ? slideIndex : 0;

          if (this.bundlePicker) {
            this.restoreIconPreviewImages();
            this.syncBundleUi();
            if (!options.skipHistory) {
              this.mosaicUnlocked = true;
            }
            if (this.mosaicUnlocked && this.mosaicSlideIndex >= 0) {
              this.showBundleMosaic({ instant: Boolean(options.instantGallery) });
            } else if (options.skipHistory || options.instantGallery) {
              this.showFirstBundleImage({ instant: true });
            }
          } else {
            this.applyVariantImage(variant, { instant: Boolean(options.instantGallery) });
            this.button.disabled = !variant.available;
            this.label.textContent = variant.available
              ? this.dataset.addLabel.replace('__PRICE__', variant.price)
              : this.dataset.soldOut;
          }

          if (!options.skipHistory) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }

          document.dispatchEvent(
            new CustomEvent('harmony:variant-change', {
              detail: { productId: Number(this.dataset.productId), variantId: variant.id, options: variant.options },
            })
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
